import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { categories } from "../data/categories";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [produitsOpen, setProduitsOpen] = useState(false);

  const otherLinks = [
    { path: "/revendeurs", label: "Revendeurs" },
    { path: "/a-propos", label: "À propos" },
    { path: "/contact", label: "Contact" },
  ];

  const produitsSubLinks = [
    { path: "/produits", label: "Tous les produits" },
    ...categories.map((c) => ({
      path: c.canonicalPath,
      label: c.categoryName,
    })),
  ];

  return (
    <header className="header" role="banner">
      <div className="nav" role="navigation" aria-label="Navigation principale">
        {/* Burger menu */}
        <button
          className="burger-menu"
          aria-label="Ouvrir le menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>

        {/* Logo centré */}
        <div className="brand">
          <Link to="/" className="brand-link" aria-label="Accueil TresorSafe">
            <img
              src="/TresorSafeLogo.webp"
              alt="logo TresorSafe"
              className="logo"
              width={90}
              height={52}
            />
            <span className="brand-name">The TresorSafe</span>
          </Link>
        </div>

        {/* Liens desktop */}
        <nav className="links desktop-links">
          <div className="nav-dropdown">
            <button
              type="button"
              className="nav-dropdown-toggle"
              aria-haspopup="true"
              aria-expanded={produitsOpen}
              onClick={() => setProduitsOpen(!produitsOpen)}
            >
              Produits
            </button>
            {produitsOpen && (
              <div className="nav-dropdown-menu">
                {produitsSubLinks.map((link) => (
                  <NavLink
                    key={link.path}
                    to={link.path}
                    onClick={() => setProduitsOpen(false)}
                  >
                    {link.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
          {otherLinks.map((link) => (
            <NavLink key={link.path} to={link.path}>
              {link.label}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Liens mobile (affichés quand burger cliqué) */}
      {menuOpen && (
        <nav className="mobile-menu">
          <span className="mobile-menu-heading">Produits</span>
          {produitsSubLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className="mobile-submenu-link"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
          {otherLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
